import Api from './utils/Api'
import './styles/app.css'
import vm from './vm'

interface ShapOptions {
  key: string
  el: string | HTMLElement
  dev?: boolean
  mode?: string
  hash?: boolean
  formatter?: () => string
  absence?: () => boolean | RegExp
}

export default class Shap {
  private _vm: any
  private _key: string
  private _dev: boolean

  constructor (private _options: ShapOptions) {
    this._key = _options.key
    this._dev = _options.dev || false
    this.render()
  }

  public render () {
    const { _key: key, _dev: dev, _options: options } = this
    const { el = '.shap-container' } = options
    const api = new Api({ key, dev })
    this._vm = vm({ el, api, options })
  }

  public spa () {
    const { _vm: vm } = this
    setTimeout(vm.render.bind(vm), 4)
  }
}
